////////////////////////////////////////////////////////////
//  Program: Audit List.jsx                               //
//  Application:  Audit  List                             //
//  Option: List of Audit                                 //
//  Developer: kiran singh                                //
//  Date: 2022-06-02                                      //
////////////////////////////////////////////////////////////
import React, { Component } from 'react';
import AuditTemplate from "../audit/AuditTemplate";
// import AuditTemplateAdd from "./audit/AuditTemplateAdd";


export class PropertyVisitTemplate extends Component {
  render() {
    return (
     <AuditTemplate {...this.props} callFrom={1}></AuditTemplate>
    )
  }
}

export default PropertyVisitTemplate;
